/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const SetPasswordDataParser = /* #__PURE__ */ parsers.object([
    ['tag', /* #__PURE__ */ parsers.exactly('set')],
    ['password', codecString],
]);
export class SetPasswordData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return SetPasswordDataParser.decode(input).map(res => new SetPasswordData(res));
    }
    static unsafeDecode(input) {
        return SetPasswordData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return SetPasswordDataParser.encode(data);
    }
    static schema() {
        return SetPasswordDataParser.schema();
    }
}
